import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import EditCategorieFieldApp, { EditCategorieFieldProps } from "./editCategorieField";
import { IndividualField } from "../editIndividualFields/editField";
import { EditCategorieProps } from "./editCategorie";
import { Entity, Metadata } from "../core/components/commonApp";
import React from "react";
export default class EditCategorieFieldsApp extends React.Component<EditCategorieProps, EditCategorieFieldsState>{
    private gridOptions: kendo.ui.GridOptions;
    private primaryKeyColors = {
        backgroundColor: "#00f700", //"#04d9ff"
        fontColor: "#000000"
    }
    constructor(props) {
        super(props);
        this.initApp();
        this.state = {
            gridData: [],
            selected: null
        }
        this.loadGridData();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                //{
                //    field: "Id",
                //    title: "Id"
                //},
                {
                    field: "Pos",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Position"]
                },
                //{
                //    field: "Kat",
                //    title: this.props.translations["WebCRM.EditIndividualCategories.Category"],
                //    template: "<div>#=data.KatName#</div>"
                //},
                {
                    field: "Feld",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Field"],
                },
                {
                    field: "Visible",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Visible"],
                    template: "# if(data.Visible) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                },
                {
                    field: "ReadOnly",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Readonly"],
                    template: "# if(data.ReadOnly) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                },
                {
                    field: "Searchable",
                    title: this.props.translations["WebCRM.EditIndividualCategories.Searchable"],
                    template: "# if(data.Searchable) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                },
                {
                    field: "VisibleExternal",
                    title: this.props.translations["WebCRM.EditIndividualCategories.ExternalVisible"],
                    template: "# if(data.VisibleExternal) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                },
                {
                    field: "ReadOnlyExternal",
                    title: this.props.translations["WebCRM.EditIndividualCategories.ExternalReadonly"],
                    template: "# if(data.ReadOnlyExternal) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                }
            ]
        };
    }

    private loadGridData = () => {
        let url = "IndividualCategory/GetIndKatFelder?indKatId=" + this.props.entity.Id;
        HTTPService.get<JsonResultClass<[]>>(url).then((result) => {
            if (result.Code === 0) {
                this.setState({ gridData: result.Data });
            }
        });
    }

    private createGrid = () => {
        let standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: Helper.hasValue(this.state.selected) },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: Helper.hasValue(this.state.selected) }
        ];
        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="tableInfoEditCategoryFieldsGrid"
                    onClickStandardButton={this.onButtonClick}
                    onSelectionChanged={(dataItem) => { this.setState({ selected: dataItem }) }}
                    onDataBound={this.handleDataBound}
                />
            </div>
        );
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: EntityIndKatFields) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.openEdit(dataItem);
                break;
            case ToolBarStandardButtonType.NEW:
                this.openEdit();
                break;
            case ToolBarStandardButtonType.DELETE:
                DialogHelper.confirm(Config.translations.deleteMessage).then((isOk) => {
                    if (isOk) {
                        HTTPService.get<JsonResultClass>("IndividualCategory/DeleteIndKatFelder?id=" + dataItem.Id).then((result) => {
                            if (result.Code === 0) {
                                NotificationHelper.showSuccessMessage(result.Message);
                                this.loadGridData();
                            } else {
                                NotificationHelper.showErrorMessage(result.Message);
                            }

                        })
                    }
                })
                break;
        }
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsPrimaryKey) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", this.primaryKeyColors.backgroundColor);
                cell.css("color", this.primaryKeyColors.fontColor);
            }
        }
    }

    private openEdit = (dataItem: EntityIndKatFields = null) => {
        let isNew = dataItem == null;
        if (isNew) {
            let item: EntityIndKatFields = {
                Id: null,
                Table: this.props.entity.Tabelle,
                Kat: this.props.entity.Id,
                KatName: this.props.entity.KatName,
                Pos: null,
                Feld: null,
                Visible: 1,
                ReadOnly: 0,
                Searchable: 1,
                VisibleExternal: 1,
                ReadOnlyExternal: 1,
                IsGuid: "",
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: null
            }
            this.openSheet(item);
        }
        else {
            dataItem.RecordRight = { CanRead: true, CanWrite: true };
            this.openSheet(dataItem);
        }
    }

    private openSheet = (entity) => {
        HTTPService.chainBatch
            .add<Metadata>(Helper.getMetaData("editCategorieField"))
            .add<JsonResultClass<IndividualField[]>>("EditIndividualFields/GetIndividualFields?tableName=" + encodeURIComponent(this.props.entity.Tabelle))
            .promise()
            .then((result) => {
                const props: EditCategorieFieldProps = {
                    entity: entity,
                    context: {
                        contextType: "editCategorieField"
                    },
                    title: "",
                    metadata: result[0],
                    dataSources: { individualFieldsDataSource: result[1].Data.filter(f => !f.IsPrimaryKey && f.ColumnName.trim().toLowerCase() != 'isguid') },
                    isWindow: false,
                }
                let sheet = General.Sheet.Manager.createSheet()
                sheet.show(() => {
                    sheet.mountContent(EditCategorieFieldApp, props);
                });
                sheet.bind(SheetEventType.SavedSuccessfully, () => { this.loadGridData() })
            })
    }

    render() {
        return (
            <>
                {this.createGrid()}
            </>
        );
    }
}

interface EditCategorieFieldsState {
    gridData: EntityIndKatFields[],
    selected: EntityIndKatFields
}

export interface EntityIndKatFields extends Entity {
    Id: number,
    Table: string,
    Kat: number,
    KatName: string,
    Feld: string,
    Visible: number,
    ReadOnly: number,
    Searchable: number,
    VisibleExternal: number,
    ReadOnlyExternal: number,
    Pos: number,
    IsGuid: string
}